export default function LoadingScreen({ message = 'Loading' }) {
  return (
    <div className="loading-screen">
      <div className="loading-ring">
        <img src="/health-icons/icon-512.png" alt="" className="brand-mark" />
      </div>
      <div className="loading-wordmark">HEALTHNEST</div>
      <div className="loading-sub">CUT PROGRAM</div>
      <div className="loading-message">{message}</div>
    </div>
  )
}
